/* eslint-disable */

const BRAND_NAME = "Wildcraft";
const COPYRIGHT_TEXT = (() => `© ${new Date().getFullYear()} wildcraft`)();
const PASTEL_COLOR_SET = ["#fef8f5", "#f9dccb", "#f2a87e"];
const BREADCRUMB_HOME = "Wildcraft";

const facebook = {
  appId: process.env.REACT_APP_FACEBOOK,
  version: "v5.0",
  scope: "email",
  url: "//connect.facebook.net/en_US/all.js",
  xfbml: true,
};

const UTM_KEYS = {
  UTM_MEDIUM: "utm_medium",
  UTM_CAMPAIGN: "utm_campaign",
  UTM_TERM: "utm_term",
  UTM_SOURCE: "utm_source"
}

export { BRAND_NAME, COPYRIGHT_TEXT, PASTEL_COLOR_SET, BREADCRUMB_HOME, facebook, UTM_KEYS };
